export default __webpack_public_path__ + "assets/models/15b27abadb7bc174e7e46db3973dd3b9.glb";